module.exports = __webpack_public_path__ + "img/咨询信息.56b01ed5.png";